// extracted by mini-css-extract-plugin
module.exports = {"product-support-faq":"FAQ_product-support-faq__CUHiS"};